import androidx.compose.runtime.CompositionLocalProvider
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable

public fun main() {
    AppGlobals.initialize(mapOf("title" to "JPUF Portfolio"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.register("/") { io.github.jpuf.portfolio.pages.HomePage() }
        ctx.router.register("/biospot/privacypolicy") {
                io.github.jpuf.portfolio.pages.biospot.PrivacypolicyPage() }
        ctx.router.register("/photography") { io.github.jpuf.portfolio.pages.PhotographyPage() }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("hero-container", io.github.jpuf.portfolio.HeroContainerStyle)
        ctx.theme.registerStyle("gallery-container", io.github.jpuf.portfolio.GalleryContainerStyle)
        ctx.theme.registerStyle("headline-text", io.github.jpuf.portfolio.HeadlineTextStyle)
        ctx.theme.registerStyle("headline-underlined-text",
                io.github.jpuf.portfolio.HeadlineUnderlinedTextStyle)
        ctx.theme.registerStyle("subheadline-text", io.github.jpuf.portfolio.SubheadlineTextStyle)
        ctx.theme.registerStyle("post-title-text", io.github.jpuf.portfolio.PostTitleTextStyle)
        ctx.theme.registerStyle("body-text", io.github.jpuf.portfolio.BodyTextStyle)
        ctx.theme.registerStyle("body-text-style-padded",
                io.github.jpuf.portfolio.BodyTextStylePadded)
        ctx.theme.registerStyle("max-width", io.github.jpuf.portfolio.MaxWidthStyle)
        ctx.theme.registerStyle("markdown",
                io.github.jpuf.portfolio.components.layouts.MarkdownStyle)
        ctx.theme.registerStyle("page-content",
                io.github.jpuf.portfolio.components.layouts.PageContentStyle)
        ctx.theme.registerStyle("footer", io.github.jpuf.portfolio.components.sections.FooterStyle)
        ctx.theme.registerStyle("nav-header",
                io.github.jpuf.portfolio.components.sections.NavHeaderStyle)
        ctx.theme.registerStyle("photography-page-content",
                io.github.jpuf.portfolio.pages.PhotographyPageContentStyle)
        ctx.theme.registerVariant("-circle", io.github.jpuf.portfolio.CircleButtonVariant
        )
        ctx.theme.registerVariant("-cornered", io.github.jpuf.portfolio.CorneredButtonVariant
        )
        ctx.theme.registerVariant("-uncolored", io.github.jpuf.portfolio.UncoloredButtonVariant
        )
        ctx.theme.registerVariant("-centre-style", io.github.jpuf.portfolio.TooltipCentreStyle
        )
        ctx.theme.registerKeyframes("side-menu-slide-in",
                io.github.jpuf.portfolio.components.sections.SideMenuSlideInAnim)
        io.github.jpuf.portfolio.initColorMode(ctx)
        io.github.jpuf.portfolio.initSiteStyles(ctx)
        io.github.jpuf.portfolio.initTheme(ctx)
    }

    router.tryRoutingTo(BasePath.remove(window.location.href.removePrefix(window.origin)),
            UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "root") {
        io.github.jpuf.portfolio.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
